<template>
  <div class="info-page">
    <crumbs title="用户管理" />
    <div class="info-page__item">
      <div class="info-page__title">
        <span>用户信息</span>
      </div>
      <div class="user-info">
        <el-row class="head-portrait" :gutter="20">
          <el-col :span="24">
            <div class="content">
              <div class="name">头像</div>
              <div class="avatar">
                <el-avatar :size="80" :src="userInfo.imgUrl">
                  <i
                    class="el-icon-user-solid"
                    style="font-size: 50px; vertical-align: middle"
                  ></i>
                </el-avatar>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="content">
              <div class="name">账号昵称</div>
              <div class="detail">{{ userInfo.account }}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="content">
              <div class="name">用户id</div>
              <div class="detail">{{ userInfo.userId }}</div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="content">
              <div class="name">认证类型</div>
              <div class="detail">{{ userType }}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="content">
              <div class="name">认证状态</div>
              <div class="detail">{{ userInfo.certificationStatusName }}</div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="content">
              <div class="name">注册时间</div>
              <div class="detail">{{ userInfo.createTime }}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="content">
              <div class="name">用户来源</div>
              <div class="detail">{{ userInfo.userSource }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div v-if="showAuth" class="info-page__item">
      <div class="info-page__title">
        <span>认证信息</span>
      </div>
      <template v-if="userType === '个人认证'">
        <div class="per-info">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="content">
                <div class="name">认证人姓名</div>
                <div class="detail">{{ userInfo.name }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="content">
                <div class="name">联系方式</div>
                <div class="detail">{{ userInfo.linkMode }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="content">
                <div class="name">联系地址</div>
                <div class="detail">{{ userInfo.regionName }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="content">
                <div class="name">所在企业</div>
                <div class="detail">{{ userInfo.companyName }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="content">
                <div class="name">邮箱</div>
                <div class="detail">{{ userInfo.email }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <template v-if="userType === '企业认证'">
        <div class="com-info">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="content">
                <div class="name">企业名称</div>
                <div class="detail">{{ userInfo.name }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="content">
                <div class="name">统一社会信用代码/组织机构代码</div>
                <div class="detail">{{ userInfo.companyUniqueCode }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="content">
                <div class="name">注册地址</div>
                <div class="detail">{{ userInfo.regionName }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="content">
                <div class="name">成立时间</div>
                <div class="detail">{{ userInfo.foundingTime }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="content">
                <div class="name">单位性质</div>
                <div class="detail">{{ userInfo.rtatCompanyNatureName }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="content">
                <div class="name">企业类型</div>
                <div class="detail">{{ userInfo.rtatTypeName }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="content">
                <div class="name">法人代表姓名</div>
                <div class="detail">{{ userInfo.legalPerson }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="content">
                <div class="name">企业电话</div>
                <div class="detail">{{ userInfo.phoneNumber }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="content">
                <div class="name">企业详细地址</div>
                <div class="detail">{{ userInfo.registerAddress }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="content">
                <div class="name">认证人姓名</div>
                <div class="detail">{{ userInfo.certifierName }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="content">
                <div class="name">联系方式</div>
                <div class="detail">{{ userInfo.certifierPhoneNumber }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </div>
    <div class="info-page__item">
      <div class="info-page__title">
        <span>用户发布数据</span>
      </div>
      <div class="issue-info">
        <div class="toolbar">
          <div class="data-type">
            <a
              v-for="item in issueTypeList"
              :key="item.name"
              href="javascript:;"
              :class="issueTypeName === item.value ? 'active' : ''"
              @click="handleIssueType(item.value)"
              >{{ item.name }}</a
            >
          </div>
        </div>
        <template v-if="Array.isArray(issueResult) && issueResult.length > 0">
          <!-- 结果 -->
          <div v-loading="isIssueLoading" class="result">
            <ul>
              <li
                v-for="item in issueResult"
                :key="item.id"
                :class="{
                  failure: item.state === '3'
                }"
              >
                <div class="box">
                  <div v-if="issueTypeName === 'achievement'" class="tag">
                    {{ item.achvTypeName }}
                  </div>
                  <div class="title">
                    <h4 class="fn-text-ellipsis">
                      <a href="javascript:;" @click="handleIssueLook(item)">{{
                        item.name
                      }}</a>
                    </h4>
                  </div>
                  <template v-if="issueTypeName === 'patent'">
                    <p>
                      <span>专利号：{{ item.applicationNumber }}</span>
                    </p>
                  </template>
                  <template v-else>
                    <p>
                      <span>编号：{{ item.code }}</span>
                    </p>
                  </template>
                  <p>
                    <span>专业领域：{{ item.specialFieldIdName }} </span>
                  </p>
                  <p>
                    <span
                      >审核状态：<em
                        :class="{
                          not: item.state === '0',
                          success: item.state === '1',
                          error: item.state === '2'
                        }"
                        >{{ item.stateName }}</em
                      >
                    </span>
                  </p>
                  <p v-if="issueTypeName !== 'patent'">
                    <span>对接人数：{{ item.dockingCount }} </span>
                    <!-- 只有技术成果有评分 -->
                    <span
                      v-if="
                        issueTypeName === 'achievement' && item.achvType === 1
                      "
                      >成果评分：{{ item.score }}
                    </span>
                  </p>
                  <p>
                    <span>发布时间：{{ item.createTime }} </span>
                  </p>
                  <p>
                    <span>更新时间：{{ item.lastUpdateTime }} </span>
                  </p>
                </div>
                <div v-if="item.state === '3'" class="failure-img"></div>
                <div v-if="item.state === '3'" class="failure-text">
                  <i class="el-icon-warning" style="padding-right: 5px"></i>
                  <span>{{ item.stateReason }}</span>
                </div>
              </li>
            </ul>
          </div>
          <!-- 分页 -->
          <div class="pagination fn-text-center">
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              :hide-on-single-page="true"
              prev-text="上一页"
              next-text="下一页"
              :pager-count="9"
              :total="issueTotal"
              :page-size="issueQuery.pageSize"
              :current-page.sync="issueQuery.pageIndex"
              @current-change="handleIssueCurrentChange"
            >
            </el-pagination>
          </div>
        </template>
        <template v-else>
          <div class="no-result">
            <div class="box">
              <img src="@/assets/images/no_issue_data.png" />
              <p class="text">没有{{ issueTypeChineseName }}信息</p>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="info-page__item">
      <div class="info-page__title">
        <span>用户对接数据</span>
      </div>
      <div class="docking-info">
        <div class="toolbar">
          <div class="data-type">
            <a
              v-for="item in dockingTypeList"
              :key="item.name"
              :class="dockingTypeName === item.value ? 'active' : ''"
              @click="handleDockingType(item.value)"
              >{{ item.name }}</a
            >
          </div>
        </div>
        <template
          v-if="Array.isArray(dockingResult) && dockingResult.length > 0"
        >
          <!-- 结果 -->
          <div v-loading="isDockingLoading" class="result">
            <ul>
              <li
                v-for="item in dockingResult"
                :key="item.id"
                :class="{
                  failure: false
                }"
              >
                <div class="title">
                  <div class="info">
                    <span>对接时间：{{ item.createTime }}</span>
                    <span>对接编号：{{ item.code }}</span>
                  </div>
                </div>
                <div class="detail">
                  <div>
                    <h4>
                      {{
                        dockingTypeName === "achievement" ? "成果" : "需求"
                      }}名称
                    </h4>
                    <p>{{ item.name }}</p>
                  </div>
                  <div v-if="dockingTypeName === 'achievement'" class="short">
                    <h4>成果分类</h4>
                    <p>{{ item.achvTypeName }}</p>
                  </div>
                  <div>
                    <h4>专业领域</h4>
                    <p>{{ item.specialFieldIdName }}</p>
                  </div>
                  <div class="short">
                    <h4>对接状态</h4>
                    <p
                      :class="item.projectStatusName === '对接中' ? 'ing' : ''"
                    >
                      {{ item.projectStatusName }}
                    </p>
                  </div>
                  <div>
                    <h4>对接操作</h4>
                    <div class="operation">
                      <a href="javascript:;" @click="handleDockingLook(item.id)"
                        >查看详情</a
                      >
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <!-- 分页 -->
            <div class="pagination fn-text-center">
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :hide-on-single-page="true"
                prev-text="上一页"
                next-text="下一页"
                :pager-count="9"
                :total="dockingTotal"
                :page-size="dockingQuery.pageSize"
                :current-page.sync="dockingQuery.pageIndex"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="no-result">
            <div class="box">
              <img src="@/assets/images/no_project_data.png" />
              <p class="text">没有对接数据</p>
              <!-- <div class="btn">开始创建</div> -->
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userContentInfo",
  data() {
    return {
      // 用户信息
      userType: "",
      userInfo: {},
      // 是否显示认证信息
      showAuth: false,
      // 用户发布的数据
      isIssueLoading: false,
      issueTypeName: "achievement",
      issueTypeList: [
        { name: "发布成果信息", value: "achievement" },
        { name: "发布需求信息", value: "demand" },
        { name: "发布专利信息", value: "patent" }
      ],
      issueQuery: {
        createBy: "",
        state: -1,
        dateOrder: 0,
        pageIndex: 1,
        pageSize: 6
      },
      issueTotal: 0,
      issueResult: null,
      // 用户对接的数据
      dockingType: {
        achievement: 1,
        demand: 2
      },
      isDockingLoading: false,
      dockingTypeName: "achievement",
      dockingTypeList: [
        { name: "成果对接管理", value: "achievement" },
        { name: "需求对接管理", value: "demand" }
      ],
      dockingQuery: {
        projectStatus: -1,
        dateOrder: 0,
        pageIndex: 1,
        pageSize: 6
      },
      dockingTotal: 0,
      dockingResult: null
    };
  },
  computed: {
    issueTypeChineseName() {
      const obj = {
        achievement: "成果",
        demand: "需求",
        patent: "专利"
      };
      return obj[this.issueTypeName];
    }
  },
  created() {
    const { type } = this.$route.params;
    const { showAuth = false } = this.$route.query;
    let name = "";
    if (type === "com") {
      name = "getComCerInfo";
      this.userType = "企业认证";
    } else {
      name = "getPerCerInfo";
      this.userType = "个人认证";
    }
    this.showAuth = showAuth;
    this.loadIssueList();
    this.loadDockingList();
    this.loadInfo(name);
  },
  methods: {
    loadInfo(name) {
      const { id } = this.$route.query;
      this.$api("user", name, {
        id
      }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.userInfo = res.dataList[0];
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 发布
    handleIssueLook(item) {
      const { id, achvType } = item;
      this.redirectByPathBlank(
        `/admin/dataManage/${this.issueTypeName}Info/modification`,
        {
          id,
          achvType:
            this.issueTypeName === "achievement"
              ? achvType === 1
                ? "tech"
                : "prod"
              : undefined
        }
      );
    },
    handleIssueCurrentChange() {
      this.loadIssueList();
    },
    handleIssueType(type) {
      if (this.issueTypeName === type) return;
      this.issueTypeName = type;
      this.issueQuery.pageIndex = 1;
      this.loadIssueList();
    },
    loadIssueList() {
      const { id } = this.$route.query;
      this.isIssueLoading = true;
      this.$api("user", "getUserIssue" + this.issueTypeName, {
        ...this.issueQuery,
        userId: id
      }).then((res) => {
        this.isIssueLoading = false;
        this.issueTotal = res.count;
        this.issueResult = res.dataList;
      });
    },
    // 对接
    handleDockingLook(id) {
      this.redirectByPathBlank(
        `/admin/dockingManage/${
          this.dockingTypeName === "achievement"
            ? "achDockingInfo"
            : "demDockingInfo"
        }`,
        {
          id
        }
      );
    },
    handleCurrentChange() {
      this.loadDockingList();
    },
    handleDockingType(type) {
      if (this.dockingTypeName === type) return;
      this.dockingTypeName = type;
      this.dockingQuery.pageIndex = 1;
      this.loadDockingList();
    },
    // 获取列表
    loadDockingList() {
      const { id } = this.$route.query;
      this.isDockingLoading = true;
      return this.$api("user", "getUserDocking", {
        ...this.dockingQuery,
        userId: id,
        dockingType: this.dockingType[this.dockingTypeName]
      }).then((res) => {
        this.isDockingLoading = false;
        this.dockingTotal = res.count;
        this.dockingResult = res.dataList;
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/userManage/userContentlist`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.info-page {
  .user-info,
  .per-info,
  .com-info {
    padding-bottom: 9px;
    font-size: 14px;
    .el-row {
      .content {
        display: flex;
        align-items: center;
        height: 40px;
        .name {
          flex: none;
          min-width: 76px;
          vertical-align: middle;
          padding-right: 30px;
          text-align: right;
          color: #999999;
        }
      }
      &.head-portrait {
        margin-bottom: 10px;
        .content {
          height: auto;
        }
      }
    }
  }
  .issue-info {
    .toolbar {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      .data-type {
        a {
          display: inline-block;
          margin-right: 50px;
          line-height: 50px;
          cursor: pointer;
          &.active,
          &:hover {
            color: @mainColor;
          }
        }
      }
    }
    .result {
      padding-top: 20px;
      ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        li {
          position: relative;
          width: 32%;
          margin-bottom: 20px;
          &:last-child:nth-child(3n + 2) {
            margin-right: 34%;
          }

          &.failure {
            h4 {
              pointer-events: none;
            }
            .box {
              opacity: 0.4;
            }
          }
          .failure-img {
            position: absolute;
            top: 50%;
            right: 15px;
            width: 92px;
            height: 82px;
            background-image: url("~@/assets/images/failure_img.png");
            transform: translateY(-50%);
          }
          .failure-text {
            line-height: 1;
            position: absolute;
            top: 10px;
            left: 50px;
            font-size: 12px;
            color: #f23b43;
          }
          .box {
            padding: 0 12px 22px 30px;
            border-radius: 6px;
            box-shadow: 0px 0px 10px 0px rgba(0, 2, 8, 0.04);
            background-image: url("~@/assets/images/user_issue_manage_bg.png");
            background-repeat: no-repeat;
            background-position: right 0 bottom 0;
            transition: 0.5s;
            &:hover {
              box-shadow: 0px 0px 30px 0px rgba(0, 2, 8, 0.1);
            }
            .tag {
              position: absolute;
              left: 0;
              top: 0;
              width: 45px;
              height: 32px;
              background-color: rgb(51, 51, 51);
              border-radius: 5px 0 16px 0;
              text-align: center;
              line-height: 32px;
              font-size: 12px;
              color: #fffefe;
            }
            .title {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 52px;
              padding-top: 14px;
              h4 {
                flex: 1;
                font-size: 20px;
                color: @mainColor;
              }
            }
            p {
              display: flex;
              justify-content: space-between;
              line-height: 30px;
              font-size: 14px;
              font-weight: 400;
              color: #666666;
              em {
                font-style: normal;
                &.not {
                  color: @mainColor;
                }
                &.success {
                  color: #38b466;
                }
                &.error {
                  color: #f23b43;
                }
              }
            }
          }
        }
      }
    }
    .pagination {
      padding-bottom: 20px;
    }
    .no-result {
      height: 308px;
      position: relative;
      .box {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        > p {
          line-height: 1;
          font-size: 12px;
          color: #999999;
          letter-spacing: 1px;
        }
      }
    }
  }
  .docking-info {
    .toolbar {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      .data-type {
        a {
          display: inline-block;
          margin-right: 50px;
          line-height: 50px;
          cursor: pointer;
          &.active,
          &:hover {
            color: @mainColor;
          }
        }
      }
    }
    .result {
      padding: 30px 0 20px;
      > ul {
        li {
          position: relative;
          margin-bottom: 30px;
          box-shadow: 0 5px 6px 1px rgba(0, 0, 0, 0.03);
          border-radius: 4px;
          &.failure {
            .title {
              color: #999999;
              background-color: #f7f7f7;
            }
            .detail {
              > div {
                p,
                .operation {
                  pointer-events: none;
                  color: #999999;
                  &.ing {
                    color: #999999;
                  }
                  a {
                    color: #999999;
                  }
                }
              }
            }
          }
          .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 44px;
            padding: 0 30px;
            border-radius: 4px;
            background-color: #f1f6fb;
            .info {
              font-size: 14px;
              span {
                padding-right: 50px;
              }
            }
          }
          .detail {
            display: flex;
            > div {
              flex: 1;
              display: flex;
              flex-direction: column;
              box-sizing: border-box;
              padding: 4px 10px 16px;
              border-right: 1px solid #f7f7f7;
              font-size: 14px;
              &:first-child {
                flex: 0 0 230px;
              }
              &.short {
                flex: 0 0 110px;
              }
              &:last-child {
                flex: 0 0 250px;
              }
              h4 {
                line-height: 44px;
                text-align: center;
                font-weight: normal;
                color: #999999;
              }
              p,
              .operation {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                line-height: 21px;
                &.ing {
                  color: #fe6115;
                }
                a {
                  margin: 0 5px;
                  color: #074492;
                  text-decoration: underline;
                }
              }
            }
          }
        }
      }
      .pagination {
        .el-pagination {
          padding: 20px 0 30px;
        }
      }
    }
    .no-result {
      height: 308px;
      position: relative;
      .box {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        > p {
          line-height: 1;
          font-size: 12px;
          color: #999999;
          letter-spacing: 1px;
        }
      }
    }
  }
}
</style>
